import React from 'react';
import { Box, Label, Paragraph, Radio } from '@zillow/constellation-10';

interface Props {
  question: {
    index: number;
    text: string;
    choices: Array<{ text: string; index: number; chosen: boolean }>;
    answered: boolean;
  };
  chooseAnswer: (index: number) => void;
}

const QuestionPage: React.FC<Props> = ({ question, chooseAnswer }) => {
  return (
    <>
      <Paragraph textStyle="body-lg-bold">Question {question.index + 1}</Paragraph>
      <Paragraph>{question.text}</Paragraph>
      {question.choices.map((choice) => (
        <Box
          key={choice.index}
          css={{
            display: 'flex',
            alignItems: 'center',
            gap: 'token(spacing.xs)',
          }}
        >
          <Radio id={`choice ${choice.index}`} checked={choice.chosen} onChange={() => chooseAnswer(choice.index)} />
          <Label>{choice.text}</Label>
        </Box>
      ))}
    </>
  );
};

export default QuestionPage;
